import { Spin, Table } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const ReportTable = ({ data, page, limit, parameters, setPage, setLimit, isLoading = false, total = 0 }) => {
  const generatedTableColumn = useMemo(() => {
    let columns = [
      {
        title: "No.",
        width: "60px",
        render: (_, __, index) => (page - 1) * limit + index + 1,
      },
      {
        title: "Time",
        render: (row) => moment(row._id).format("DD/MM/YYYY hh:mm:ss a"),
        width: "200px",
        center: true,
      },
    ];
    if (parameters.length > 0) {
      columns = [
        ...columns,
        ...parameters.map(({ label }) => {
          return {
            title: label,
            render: (row) => (Number.isFinite(Number(row?.[label])) ? Number(row?.[label]).toFixed(2) : "--"),

            align: "center",
          };
        }),
      ];
    }
    return columns;
  }, [parameters, page, limit]);

  return (
    <div className="p-3">
      <Spin spinning={isLoading}>
        {/* <Table
          columns={generatedTableColumn}
          dataSource={data}
          pagination={{
            onChange: (_p, size) => {
              setPage(_p);
              setLimit(size);
            },
          }}
        /> */}

        <Table
          dataSource={data}
          columns={generatedTableColumn}
          rowKey={(record) => record.id}
          scroll={{ x: true }}
          pagination={{
            defaultPageSize: limit,
            current: page,
            total,
            showSizeChanger: true,
            showLessItems: true,
            showQuickJumper: true,
            onShowSizeChange: (_, pageSize) => {
              setLimit(pageSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            pageSizeOptions: [10, 20, 50],
            responsive: true,
          }}
          onChange={(pagination) => {
            setPage(pagination.current);
          }}
        />
      </Spin>
    </div>
  );
};

export default ReportTable;

ReportTable.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  parameters: PropTypes.array.isRequired,
  setPage: PropTypes.func.isRequired,
  setLimit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
